<div class="c-d-flex">
  <muni-gameday-sealed-bid></muni-gameday-sealed-bid>
  <muni-gameday-stock-toggle></muni-gameday-stock-toggle>
  <muni-gameday-filter-by-series
    data-automation-e2e-selector="filterBySeries"
  ></muni-gameday-filter-by-series>
  <muni-gameday-version-selector></muni-gameday-version-selector>
  <muni-gameday-export-report-icon></muni-gameday-export-report-icon>
</div>
